<!--
 * @Descripttion:
 * @version: 0.0.1
 * @Author: ZHJI
 * @Date: 2019-09-25 09:23:56
 * @LastEditors: ZHJI
 * @LastEditTime: 2019-11-12 17:10:00
 -->
<!--  -->
<template>
    <basicContainer>
        <div class="announcementManage">
            <!-- 主数据表 -->
            <easyCruds ref="mainTable" :tableInfo="mainTable"
                      @mainTableReload="mainTableReload"
                      @uploadFile="uploadFile"
                      @toUploadFile="toUploadFile"
                      @downloadViewFunc='downloadViewFunc'
                      @downloadDataFun='downloadDataFun'
                      @todownloadData='todownloadData'
                      @xyChange="xyChange"
                      @toDownloadView="toDownloadView">
            </easyCruds>

            <!-- 导入模板选择试图 -->
            <el-dialog  title="导入模板" :visible.sync="uploadView.show" width="30%" top="15vh" :append-to-body="true"  @close='closeUploadDialog'>
                <el-row>
                    <el-form :inline="true"  ref="downloadView" :model="uploadView.form" label-suffix=":">
                        <el-col :span="24" ref="uploadViewData">
                            <input type="file" class="file" @change="uploading($event)">
                            <el-button type="success" class="file_btn"><i class="el-icon-upload"></i><span v-text="uploadViewData.label">上传文件</span></el-button>
                        </el-col>
                    </el-form>
                </el-row>
                <span slot="footer" >
              <el-button @click="uploadView.show = false">取 消</el-button>
              <el-button type="primary" @click="toUploadFile">确定上传</el-button>
            </span>
            </el-dialog>

            <!-- 下载模板 -->
            <el-dialog  title="下载模板" :visible.sync="downloadView.show" width="30%" top="15vh" :append-to-body="true">
                <el-row>
                    <el-form :inline="true"  ref="downloadView" :model="downloadView.form" label-suffix=":">
                        <el-col :span="24">
                            <el-form-item label="文件名称"  prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"  :required="true">
                                <el-input v-model="downloadView.form.fileName">
                                    <template slot="append">.xlsx</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                <span slot="footer" >
              <el-button @click="downloadView.show = false">取 消</el-button>
              <el-button type="primary" @click="toDownloadView">确 定</el-button>
            </span>
            </el-dialog>

            <!-- 导出数据 -->
            <el-dialog  title="导出数据" :visible.sync="downloadData.show" width="30%" top="15vh" :append-to-body="true">
                <el-row>
                    <el-form :inline="true"  ref="downloadView" :model="downloadData.form" label-suffix=":">
                        <el-col :span="24">
                            <el-form-item label="文件名称"  prop="fileName" :rules="[{ 'required': true, 'message': '请输入文件名' }]"  :required="true">
                                <el-input v-model="downloadData.form.fileName">
                                    <template slot="append">.xlsx</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-form>
                </el-row>
                <span slot="footer" >
              <el-button @click="downloadData.show = false">取 消</el-button>
              <el-button type="primary" @click="todownloadData">确 定</el-button>
            </span>
            </el-dialog>

        </div>
    </basicContainer>
</template>

<script>
    export default {
        components: {

        },
        data() {
            return {
                downloadParams: [],
                downloadView: {
                    show: false,
                    form: {
                        excelTemplateType: '',
                        fileName: '专业信息模板'
                    }
                },
                downloadData: {
                    show: false,
                    form: {
                        excelTemplateType: '',
                        fileName: '导出专业信息数据'
                    }
                },
                mainTable: {
                    buttonSetting: {
                        allowAdd: false,
                        allowEdit: false,
                        allowDelete: false,
                        allowView: true,
                        left: [{
                            title: '下载模板',
                            type: 'primary',
                            clickEvent: 'downloadViewFunc',
                            icon: 'el-icon-download'
                        }, {
                            title: '导入',
                            type: 'success',
                            clickEvent: 'uploadFile',
                            icon: 'el-icon-upload'
                        }, {
                            title: '导出',
                            type: 'danger',
                            clickEvent: 'downloadDataFun',
                            icon: 'el-icon-download'
                        }], right: [

                        ]
                    },
                    header: {
                        title: '专业信息'
                    },
                    table: {
                        loading: false,
                        height: 550,
                        stripe: true,
                        conditionLabelWidth: 'auto',
                        selection: true,
                        index: true,
                        columns: [
                            {
                            prop: 'bmmc',
                            label: '开设学院',
                            isSearchCondition: true,
                            type: 'select',
                            span: 12,
                            searchChangeFunction: 'xyChange',//原学院触发事件
                             onChange: (item, value, cpmpution) => {
                                    if (!value) {
                                        this.$set(cpmpution.data,'zymc', '')
                                        return
                                    }
                                   // cpmpution.data.zymc = ''
                                    this.xyChange({ value }, null, (dicData) => {
                                        cpmpution.form.formItems.forEach(ele => {
                                            if (ele.prop === 'yzy') {
                                                this.$set(ele, 'dicData', dicData)
                                            }
                                        })
                                    })
                             },
                        },{
                            prop: 'zydm',
                            label: '专业代码',
                            isSearchCondition: false,
                            type: 'select',
                            width: 150,
                            span: 12,
                            showInTable:true,
                            dicData: []
                        },
                            {
                            prop: 'zymc',
                            label: '专业名称',
                            isSearchCondition: true,
                            type: 'select',
                            span: 12,
                        },  {
                            prop: 'zyfxdm',
                            label: '专业方向代码',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                            dicData: [],
                            showInTable: false //隐藏当前列
                        },{
                            prop: 'zyfxmc',
                            label: '专业方向名称',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                            dicData: []
                        }, {
                            prop: 'zynd',
                            label: '专业年度',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                            width: 160,
                        }, {
                            prop: 'bmid',
                            label: '开设学院',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                            showInTable:false,
                            view: [false, false, false]
                        },{
                            prop: 'xz',
                            label: '学制',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                            width:100,
                        },{
                            prop: 'zdsj',
                            label: '添加时间',
                            isSearchCondition: false,
                            type: 'select',
                            span: 12,
                        }],
                        operation: {
                            width: '120',
                        },
                        tableData: [],
                        paging: {
                            currentPage: 1,
                            pageSizes: [10, 15, 20, 25],
                            pageSize: 10,
                            total: 0
                        },
                        reload: 'mainTableReload',
                        reloadConditions: {},
                        addDefultValue: {}
                    }

                },
                uploadView: {
                    show: false,
                    form: {
                        excelTemplateType: '',
                        fileName: '专业信息模板'
                    }
                },

                uploadViewData: {
                    label: '上传文件'
                }
            }
        },

        mounted() {
            /* 列表渲染*/
            this.mainTableReload({ pageNum: 1, pageSize: 10 })
            /* 专业代码select渲染*/
            //this.getZYDM()

            /* 开设学院select渲染*/
            this.getKSXY()
        },
        methods: {
            mainTableReload: function(params) {
                this.downloadParams = params
                params.bmid = params.bmmc
                delete params['bmmc']

                params.zydm = params.zymc
                delete params['zymc']
                this.mainTable.table.loading = true
                this.$http.get('/specialty/query', {
                    params
                }).then(
                    response => {
                        this.mainTable.table.loading = false
                        // 成功之后的数据
                        this.mainTable.table.tableData = response.data.records
                        this.mainTable.table.paging.total = response.data.total || response.data.records.length

                    }
                ).catch(error => {
                    this.mainTable.table.loading = false
                    this.$message.error(error.msg)

                })
            },
            xyChange: function(val, data, callback) {
                if (!val.value && !callback) {
                    (data.yzy = data.ybj = data.zymc='')
                    return
                } else if (!val.value && callback) {
                    typeof callback === 'function' && callback([])
                }

                this.$http.get('/specialty/getZyxxByXy', { params: {
                        bmid: val.value
                    }}).then(response => {
                    let result = []
                    response.data.forEach(element => {
                        result.push({
                            label: element.zymc,
                            value: element.zydm
                        })
                    })
                    if (callback) {
                        typeof callback === 'function' && callback(result)
                    } else {
                        this.$refs.mainTable.setColumnSeting('zymc', 'dicData', result)
                       // this.$refs.mainTable.setColumnSeting('zydm', 'dicData', result)
                        let that = this
                     //   that.mainTable.table.reloadConditions.zydm = ''
                        that.mainTable.table.reloadConditions.zymc = ''

                    }
                }).catch(error => {
                    this.$message.error(error.msg)
                })
            },
            showSystemDate: function(){
                let nowDate = new Date();
                let date = {
                    year: nowDate.getFullYear(),
                    month: nowDate.getMonth() + 1,
                    date: nowDate.getDate(),
                }
                if(date.month<10){
                    date.month = '0'+date.month
                }
                if(date.date<10){
                    date.date = '0'+date.date
                }
                let systemDate = date.year + '-' + date.month  + '-' + date.date;
                return systemDate
            },

            getKSXY: function() {
                this.$http.post('/college/getCollegeCode').then(response => {
                    if (response.code === 200) {
                        let result = []
                        response.data.forEach(element => {
                            result.push({
                                label: element.bmmc,
                                value: element.bmdm
                            })
                        })
                        this.$refs.mainTable.setColumnSeting('bmmc', 'dicData', result)
                        this.$refs.mainTable.setColumnSeting('bmid', 'dicData', result)
                    } else {
                        this.$message.error(response.msg)
                    }
                }).catch(error => {
                    this.$Log.capsule('专业信息', error, 'danger')
                })
            },

            downloadViewFunc: function() {
                this.downloadView.show = true
                if (this.$refs.downloadView) {
                    this.$refs.downloadView.resetFields()
                }
                this.downloadView.form = {
                    excelTemplateType: '',
                    fileName: '专业信息导入模板'
                }
            },
            toDownloadView: function() {
                this.$refs.downloadView.validate((valid) => {
                    if (valid) {
                        this.$downloadFile.get('/specialty/templateExport', { params: {
                                fileName: this.downloadView.form.fileName + '.xlsx',
                                doDownload: true
                            }}).then(response => {
                            // 返回的内容
                          this.$message.success(response.msg)
                          // 返回的内容
                          this.downloadView.show = false

                        }).catch(error => {
                            this.$message.error(error)
                        })
                    }
                })
            },
            downloadDataFun: function() {
                this.downloadData.show = true
                if (this.$refs.downloadData) {
                    this.$refs.downloadData.resetFields()
                }
                let ststemDate = this.showSystemDate()
                this.downloadData.form = {
                    excelTemplateType: '',
                    fileName: '专业信息_'+ststemDate
                }
            },
            todownloadData: function() {
                // let params = this.$refs.mainTable.getReloadConditions()
                // params.bmid = params.bmmc
                // delete params['bmmc']

                // params.zydm = params.zymc
                // delete params['zymc']
               let params = this.downloadParams

                params.fileName = this.downloadData.form.fileName + '.xlsx'
                params.doDownload = true

                this.$refs.downloadView.validate((valid) => {
                    if (valid) {
                        this.$downloadFile.get('/specialty/dataExport', { params}).then(response => {
                            this.$message.success(response.msg)
                            // 返回的内容
                            this.downloadData.show = false

                        }).catch(error => {
                            this.$message.error(error)
                        })
                    }
                })
            },
            uploadFile: function() {
                this.uploadView.show = true
                this.uploadView.form = {
                    excelTemplateType: '',
                    fileName: '导出专业信息数据'
                }
            },
            toUploadFile: function() {
                let formData = new window.FormData() // vue 中使用 window.FormData(),否则会报 'FormData isn't definded'
                formData.append('file', this.file)
                let config = {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    }
                }
                this.$http.post('/specialty/excelImport', formData, config).then((res) => {
                    this.$message.success('文件上传成功!')
                    this.uploadView.show = false
                }).catch((error) => {
                    this.$message.error(error.msg)
                })
            },

            uploading(event) {
                this.file = event.target.files[0]// 获取文件

                var windowURL = window.URL || window.webkitURL

                this.file = event.target.files[0]

                // 创建图片文件的url

                this.src = windowURL.createObjectURL(event.target.files[0])

                this.uploadViewData.label = this.file.name
            },
          closeUploadDialog: function () {
            this.uploadViewData.label='上传文件'
          }
        }
    }
</script>

<style lang='scss'>

    .quill-editor {
        height: 300px;
    }

</style>
<style lang='scss' scoped>
    .file {
        z-index: 999;
        opacity: 0;
        position: absolute;
        left: 2px;
        width: 240px;
        cursor: pointer;
        height: 44px;
    }
    .file_btn {
        position: absolute;
        left: 2px;
        width: auto;
        z-index: 0;
    }
</style>
